























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { UserSessionResult, SessionResult, SessionFeedback } from "@/types";
import reviewResult from "@/components/review/reviewResult.vue";
import reviewFeedbackRubric from "@/components/review/reviewFeedbackRubric.vue";
import { Results } from '../../types/NewResults';

@Component({
  components: {
    reviewResult,
    reviewFeedbackRubric
  }
})
export default class ReviewSession extends Vue {
  
  @Prop() private teamID!: string;
  @Prop() private sessionID!: string;
  @Prop() private sessionReviewed!: string;
  @Prop() private userFromLearner!: string;
  @Prop() private learnerName!: string;

  @Action private setTranscriptStartIndex!: any;
  @Action private setTranscriptEndIndex!: any;
  @Action private setNewReviewCommentVisible!: any;
  @Action private setReviewCommentSelectedIndex!: any;
  @Action private setReviewCommentPlay!: any;
  @Action private setRubricData!: any;
  @Action private setRubricSessionAnswers!: any;
  @Action private setRubricSessionAnswersByUser!: any;
  @Action private setRubricSessionAverageAnswers!: any;
  @Action private setReviewFeedbackComments!: any;

  private isUserFromLearner: boolean = true;
  private token: string | undefined;

  private created() {
    const token = this.$route.query['token']
    if (typeof token === 'string' && token !== '') {
      this.token = token
    }

    if (this.userFromLearner && this.userFromLearner === "true") {
      this.isUserFromLearner = true;
    } else {
      this.isUserFromLearner = false;
    }
    this.setTranscriptStartIndex(-1);
    this.setTranscriptEndIndex(-1);
    this.setReviewCommentSelectedIndex(-1);
    this.setReviewCommentPlay(-1);
    this.setNewReviewCommentVisible(false);
    this.setRubricData(null);
    this.setRubricSessionAnswers(null);
    this.setRubricSessionAnswersByUser(null);
    this.setRubricSessionAverageAnswers(null);
    this.setReviewFeedbackComments(null);
  }

  get isManager() {
    return !this.isUserFromLearner && this.teamID
  }
}
